/* lp-reviews — <lp-reviews>: lazy-fetch a curated JSON asset, render cards (first name only), filters, dialog. */
(function () {
  'use strict';
  if (window.customElements.get('lp-reviews')) return;

  var STAR = '<svg class="lp-icon lp-icon--fill" viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z"/></svg>';
  var TICK = '<svg class="lp-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function firstName(n) { return esc(String(n || '').trim().split(/\s+/)[0]); }
  function stars(n) { var out = ''; for (var i = 0; i < Math.max(0, Math.min(5, Math.round(n || 5))); i++) out += STAR; return out; }

  class LpReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-lp-track]');
      this.dialog = this.querySelector('[data-lp-dialog]');
      this.filterBox = this.querySelector('.lp-reviews__filters');
      this.limit = parseInt(this.dataset.limit, 10) || 6;
      this.category = 'all';
      this.all = [];
      var n = Math.min(this.limit, 3);
      this.track.innerHTML = Array(n + 1).join('<div class="lp-reviews__skeleton" aria-hidden="true"></div>');
      if ('IntersectionObserver' in window) {
        var self = this;
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); self.load(); }
        }, { rootMargin: '400px 0px' });
        io.observe(this);
      } else { this.load(); }
      this.track.addEventListener('click', this.onCardClick.bind(this));
      this.track.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.onCardClick(e); } }.bind(this));
      this.initNav();
    }
    load() {
      var self = this;
      fetch(this.dataset.src, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : []; }).then(function (data) {
        self.all = Array.isArray(data) ? data.filter(function (r) { return r && r.body; }) : [];
        self.renderFilters();
        self.render();
      }).catch(function () { self.track.innerHTML = ''; });
    }
    renderFilters() {
      if (!this.filterBox) return;
      var cats = {};
      this.all.forEach(function (r) { if (r.category) cats[r.category] = true; });
      var keys = Object.keys(cats);
      if (keys.length < 2) { this.filterBox.remove(); this.filterBox = null; return; }
      var self = this;
      this.filterBox.innerHTML = ['all'].concat(keys).map(function (k) {
        return '<button type="button" class="lp-reviews__filter" role="tab" data-cat="' + esc(k) + '" aria-selected="' + (k === 'all') + '">' + esc(k === 'all' ? 'All' : k.charAt(0).toUpperCase() + k.slice(1)) + '</button>';
      }).join('');
      this.filterBox.hidden = false;
      this.filterBox.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cat]'); if (!b) return;
        self.category = b.dataset.cat;
        Array.prototype.forEach.call(self.filterBox.querySelectorAll('[data-cat]'), function (x) { x.setAttribute('aria-selected', x === b); });
        self.render();
      });
    }
    render() {
      var self = this;
      var list = this.all.filter(function (r) { return self.category === 'all' || r.category === self.category; }).slice(0, this.limit);
      this.track.innerHTML = list.map(function (r, i) {
        return '<article class="lp-card lp-reviews__card" tabindex="0" role="button" data-i="' + i + '" aria-label="Read full review">' +
          '<span class="lp-reviews__card-stars" aria-label="' + esc(r.rating || 5) + ' out of 5">' + stars(r.rating) + '</span>' +
          (r.title ? '<h3 class="lp-reviews__title">' + esc(r.title) + '</h3>' : '') +
          '<p class="lp-reviews__body">' + esc(r.body) + '</p>' +
          '<p class="lp-reviews__meta"><strong>' + firstName(r.name) + '</strong>' + TICK + ' Verified</p>' +
          '</article>';
      }).join('');
      this.current = list;
      if (window.LP && window.LP.init) window.LP.init(this);
      this.updateNav();
    }
    /* desktop arrows: one card per press over native scroll-snap; disabled at either end, hidden when nothing scrolls */
    initNav() {
      var wrap = this.querySelector('[data-lp-carousel]'); if (!wrap) return;
      var prev = wrap.querySelector('[data-lp-prev]'), next = wrap.querySelector('[data-lp-next]');
      if (!prev && !next) return;
      var self = this;
      this.nav = { wrap: wrap, prev: prev, next: next };
      function step(dir) {
        var card = self.track.firstElementChild; if (!card) return;
        var gap = parseFloat(getComputedStyle(self.track).columnGap) || 0;
        self.track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: (window.LP && window.LP.motionOK) ? 'smooth' : 'auto' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      var t, sync = function () { clearTimeout(t); t = setTimeout(function () { self.updateNav(); }, 60); };
      this.track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
    }
    updateNav() {
      if (!this.nav) return;
      var tr = this.track, max = tr.scrollWidth - tr.clientWidth;
      this.nav.wrap.dataset.scrollable = max > 2;
      if (this.nav.prev) this.nav.prev.disabled = tr.scrollLeft <= 2;
      if (this.nav.next) this.nav.next.disabled = tr.scrollLeft >= max - 2;
    }
    onCardClick(e) {
      var card = e.target.closest('.lp-reviews__card'); if (!card || !this.dialog || !this.dialog.showModal) return;
      var r = this.current[parseInt(card.dataset.i, 10)]; if (!r) return;
      this.dialog.querySelector('[data-lp-dialog-body]').innerHTML =
        '<span class="lp-reviews__card-stars">' + stars(r.rating) + '</span>' +
        (r.title ? '<h3 class="lp-reviews__title">' + esc(r.title) + '</h3>' : '') +
        '<p class="lp-reviews__body">' + esc(r.body) + '</p>' +
        '<p class="lp-reviews__meta"><strong>' + firstName(r.name) + '</strong>' + TICK + ' Verified</p>';
      this.dialog.showModal();
    }
  }
  window.customElements.define('lp-reviews', LpReviews);
})();
